var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { staticClass: "root", attrs: { tag: "w-list" } },
    _vm._l(_vm.purchase.Ledgers, function (ledger, i) {
      return _c(
        "w-list-item",
        { key: i, class: { selected: _vm.selectedItem == ledger } },
        [
          _c("w-list-item-text", [
            _c("div", [_vm._v(_vm._s(_vm.ledgerToText(ledger)))]),
            _c("div", { staticClass: "comment" }, [
              _vm._v(_vm._s(ledger.Comment) + "​"),
            ]),
          ]),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.edit"),
                      expression: "$ct('common.edit')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.edit(ledger)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.delete"),
                      expression: "$ct('common.delete')",
                    },
                  ],
                  staticClass: "danger",
                  on: {
                    click: function ($event) {
                      return _vm.deleteItem(i)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }